import { Context } from 'react'
import MainComponentEvents from '../MainComponentEvents'

interface Props {
  mainComponentId: EntityId
  context?: Context<any> | null | undefined
  height?: string
  autoHeight?: boolean
  maxVisibleRowCount?: number
  minimalEmptyStatus?: boolean
  setDataLength?: (length: number) => void
}

const MainComponentEventsInEquipment = (props: Props) => {
  const { mainComponentId, context, height, autoHeight, maxVisibleRowCount, minimalEmptyStatus, setDataLength } = props

  return (
    <MainComponentEvents
      mainComponentId={mainComponentId}
      context={context}
      withoutLayout
      height={height}
      autoHeight={autoHeight}
      maxVisibleRowCount={maxVisibleRowCount}
      minimalEmptyStatus={minimalEmptyStatus}
      setDataLength={setDataLength}
    />
  )
}

export default MainComponentEventsInEquipment
